<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.lotnumber') }} > {{ $t('sidebar.create') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <ImsLotNumberForm
        :lotCode="lotLatestCode || ''"
        :isSubmitted="isSubmitted"
        :warehouses="warehouses"
        :products="products"
        :disabled="disabled"
        :selectedWhId.sync="selectedWhId"
        :form.sync="form"
        @onSubmit="handleSubmit"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { toISODateString } from '@/helpers'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  mixins: [discardFormMixin],
  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      selectedWhId: null,
      form: null,
    }
  },

  computed: {
    ...mapState('lot', {
      lotLatestCode: 'lotLatestCode',
    }),
    ...mapGetters({
      sidebar: 'getSidebar',
      warehouses: 'getWarehouses',
      products: 'getProducts',
      getProductInfoBySkuId: 'getProductInfoBySkuId',
    }),
  },

  watch: {
    warehouses () {
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 6,
        submenuAtIdx: 1,
      })
    },
    selectedWhId () {
      this.getLotLatestCode({ wh_id: this.selectedWhId })
    },
  },

  async created () {
    this.fetchData()
  },

  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 7,
      },
    })
    // set sidebar stockcontrols ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 6,
      submenuAtIdx: 1,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('lot', {
      getLotLatestCode: 'getLotLatestCode',
      createLot: 'createLot',
    }),
    async fetchData () {
      this.loading = true
      await Promise.all([
        this.$store.dispatch('getWarehouses'),
        this.$store.dispatch('getProducts'),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    getFormCreate (form = {}) {
      const productInfo = this.getProductInfoBySkuId(form.skuId)
      const productId = productInfo.product_id
      const stockId = productInfo
        .prices.find((price) => price.sku_id === form.skuId)
        .stocks.find((stock) => stock.warehouse_id === form.whId)
        .stock_id
      return {
        'stock_id': stockId,
        'sku_id': form.skuId,
        'product_id': productId,
        'wh_id': form.whId,
        'bin_location_id': form.binId,
        'gr_id': null,
        'po_id': null,
        'date_in': toISODateString(form.dateIn),
        'date_product': toISODateString(form.dateProduct),
        'date_expire': toISODateString(form.dateExpire),
        'unit_init': form.unit,
        'cost': form.cost,
        'note': form.note,
      }
    },
    async handleSubmit (form = {}) {
      this.disabled = true
      this.isSubmitted = true
      const data = this.getFormCreate(form)
      const responseCreate = await this.createLot(data)
      if (responseCreate.success) {
        this.disabled = false
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: responseCreate.data.lot_code }),
          color: 'success',
          icon: 'cloud',
        })
        this.$router.push({ name: 'InventoryLotList' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/inventory/lotnumber/Create.vue